import Link from "next/link";
import Image from "next/image";
import { handleImage } from "@/context/utilities";

const CourseWidget = ({
  data,
  courseStyle,
  showDescription,
  showAuthor,
  isProgress,
  isCompleted,
  isEdit,
  button,
  href,
  image,
  progressTitle,
  locked,
  tooltip,
}) => {
  const tooltipText = tooltip || "This subject is locked for your account";

  return (
    <>
      <div
        className="rbt-card variation-01 rbt-hover"
        {...(locked ? { "data-tooltip": tooltipText, tabIndex: "0" } : {})}
      >
        {image && (
          <div className="rbt-card-img">
            {locked ? (
              <Image
                width={330}
                height={200}
                src={handleImage(
                  data?.thumbnail?.[0]?.Location || data?.photoURL
                )}
                alt={data.displayName || data.subtopic}
              />
            ) : (
              <Link href={href || "#"}>
                <Image
                  width={330}
                  height={200}
                  src={handleImage(
                    data?.thumbnail?.[0]?.Location || data?.photoURL
                  )}
                  alt={data.displayName || data.subtopic}
                />
              </Link>
            )}
          </div>
        )}

        <div className={image ? "rbt-card-body" : ""}>
          {courseStyle === "two" && (
            <h6 className="rbt-card-title fs-4">
              {locked ? (
                data.displayName || data.subtopic
              ) : (
                <Link href={href || "#"}>
                  {data.displayName || data.subtopic}
                </Link>
              )}
            </h6>
          )}
          {showDescription && (
            <p className="rbt-card-text">{data.shortDescription}</p>
          )}
          {data.lectures && (
            <ul className="rbt-meta">
              <li>
                <i className="feather-book" />
                {data.lectures} Lessons
              </li>
            </ul>
          )}

          {isProgress ? (
            <>
              <div className="rbt-progress-style-1 mb--20 mt--10">
                <div className="single-progress">
                  <h6 className="rbt-title-style-2 mb--10">
                    {progressTitle ? progressTitle : "Completed"}
                  </h6>
                  {isCompleted ? (
                    <div className="progress">
                      <div
                        className="progress-bar wow fadeInLeft bar-color-success"
                        data-wow-duration="0.5s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        style={{ width: `100%` }}
                        aria-valuenow={100}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                      <span className="rbt-title-style-2 progress-number">
                        100%
                      </span>
                    </div>
                  ) : (
                    <div className="progress">
                      <div
                        className="progress-bar wow fadeInLeft bar-color-success"
                        data-wow-duration="0.5s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        style={{
                          width: `${Number(data.progressValue * 100).toFixed(
                            2
                          )}%`,
                        }}
                        aria-valuenow={Number(data.progressValue * 100).toFixed(
                          2
                        )}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                      <span className="rbt-title-style-2 progress-number">
                        {Number(data.progressValue * 100).toFixed(2)}%
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="rbt-card-bottom">
                {locked ? (
                  <button
                    type="button"
                    className="rbt-btn btn-sm bg-primary-opacity w-100 text-center"
                    disabled
                  >
                    <i className="feather-lock me-2"></i>
                    {button}
                  </button>
                ) : (
                  <Link
                    className="rbt-btn btn-sm bg-primary-opacity w-100 text-center"
                    href={href || "#"}
                  >
                    {button}
                  </Link>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {courseStyle === "one" && (
            <h4 className="rbt-card-title">
              <Link href={href || "#"}>{data.title}</Link>
            </h4>
          )}

          {courseStyle === "two" && showAuthor && (
            <div className="rbt-author-meta mb--20">
              <div className="rbt-avater">
                <Link href="components/widgets#">
                  <Image
                    width={40}
                    height={40}
                    src={handleImage(
                      data?.thumbnail?.[0]?.Location || data?.photoURL
                    )}
                    alt="Sophia Jaymes"
                  />
                </Link>
              </div>
              <div className="rbt-author-info">
                By <Link href="#">Patrick</Link> In{" "}
                <Link href="#">Languages</Link>
              </div>
            </div>
          )}

          {courseStyle === "one" && (
            <div className="rbt-review">
              <div className="rating">
                {Array.from({ length: 1 }, (_, i) => (
                  <i className="fas fa-star" key={i} />
                ))}
              </div>
              <span className="rating-count"> ({1} Reviews)</span>
            </div>
          )}

          {!isProgress ? (
            <div className="rbt-card-bottom">
              {data.offerPrice ||
                (data.coursePrice && (
                  <div className="rbt-price">
                    {data.offerPrice && (
                      <span className="current-price">${data.offerPrice}</span>
                    )}
                    {data.coursePrice && (
                      <span className="off-price">${data.coursePrice}</span>
                    )}
                  </div>
                ))}

              {isEdit ? (
                <Link className="rbt-btn-link left-icon" href="#">
                  <i className="feather-edit"></i> Edit
                </Link>
              ) : (
                <Link className="rbt-btn-link" href={href}>
                  {button ? button : "Watch"}
                  <i className="feather-arrow-right" />
                </Link>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default CourseWidget;
